(function () {
    angular.module('tmx-app').controller('GuarantorDetailDialogController', ['$mdDialog', '$scope', 'guarantorData', 'lookupService', 'showAddButton', 'guarantorTabEditPrivilege', 'guarantorTabDeletePrivilege', 'ClientID', 'RoleId','$filter', 'ToastService', 'cacheStore', 'tmxUtility', 'TMX_FINANCE_CONSTANTS', 'tmxResource', 

        function GuarantorDetailDialogController($mdDialog, $scope, guarantorData, lookupService, showAddButton, guarantorTabEditPrivilege, guarantorTabDeletePrivilege, ClientID, RoleId, $filter, ToastService, cacheStore, tmxUtility, TMX_FINANCE_CONSTANTS, tmxResource) {


		/****************Variable Declaration***********************/

            var exists = tmxUtility.exists;
            var LoggedInUserConfigurations = cacheStore.get("Configurations");
            var loggedInTenantName = "";
            var tenants = TMX_FINANCE_CONSTANTS.TENANTS;
            var LkpHiddenValue = TMX_FINANCE_CONSTANTS.LOOKUP_HV;
            var imagePreviewPopups = [];
            var guarantorChecklists = [{
                "form_name":"/TmxGuarantorChecklist{ProductChecklistId:31}",
                "name":"Guarantor's Photo",
                "required":true,
                "ProductChecklistId":31
           },
           {
                "form_name":"TmxGuarantorChecklist{ProductChecklistId:32}",
                "name":"Guarantor's ID",
                "required":true,
                "ProductChecklistId":32
           },
           {
                "form_name":"TmxGuarantorChecklist{ProductChecklistId:25}",
                "name":"Guarantor CDR Document",
                "required":true,
                "ProductChecklistId":25
           },
           {
                "form_name":"TmxGuarantorChecklist{ProductChecklistId:26}",
                "name":"Additional Guarantor CDR Document",
                "required":true,
                "ProductChecklistId":26
           },
           {
                "form_name":"TmxGuarantorChecklist{ProductChecklistId:27}",
                "name":"Guarantor CDR Result",
                "required":true,
                "ProductChecklistId":27
           },
           {
                "form_name":"TmxGuarantorChecklist{ProductChecklistId:28}",
                "name":"Additional Guarantor CDR Result",
                "required":true,
                "ProductChecklistId":28
           },
           {
                "form_name":"TmxGuarantorChecklist{ProductChecklistId:33}",
                "name":"Residency Card",
                "required":true,
                "ProductChecklistId":33
           },
           {
                "form_name":"TmxGuarantorChecklist{ProductChecklistId:34}",
                "name":"Doc1 Relation with Banks and Financial Institutions",
                "required":true,
                "ProductChecklistId":34
           },
           {
                "form_name":"TmxGuarantorChecklist{ProductChecklistId:35}",
                "name":"Doc2 Relation with Banks and Financial Institutions",
                "required":true,
                "ProductChecklistId":35
           },
           {
                "form_name":"TmxGuarantorChecklist{ProductChecklistId:36}",
                "name":"Doc3 Relation with Banks and Financial Institutions",
                "required":true,
                "ProductChecklistId":36
           },
           {
                "form_name":"TmxGuarantorChecklist{ProductChecklistId:38}",
                "name":"Guarantor's Employment Salary Certificate",
                "required":true,
                "ProductChecklistId":38
           },
           {
                "form_name":"TmxGuarantorChecklist{ProductChecklistId:39}",
                "name":"Guarantor Original Pay Slip",
                "required":true,
                "ProductChecklistId":39
           },
           {
                "form_name":"TmxGuarantorChecklist{ProductChecklistId:40}",
                "name":"Guarantor's Military ID",
                "required":true,
                "ProductChecklistId":40
           },
           {
                "form_name":"TmxGuarantorChecklist{ProductChecklistId:41}",
                "name":"Guarantor's Retirement Book",
                "required":true,
                "ProductChecklistId":41
           },
           {
                "form_name":"TmxGuarantorChecklist{ProductChecklistId:42}",
                "name":"Additional Retirement Book",
                "required":true,
                "ProductChecklistId":42
           },
           {
                "form_name":"TmxGuarantorChecklist{ProductChecklistId:43}",
                "name":"Guarantor's Proof Ministry of Finance OR Statement of Account",
                "required":true,
                "ProductChecklistId":43
           },
           {
                "form_name":"TmxGuarantorChecklist{ProductChecklistId:44}",
                "name":"Miscellaneous",
                "required":true,
                "ProductChecklistId":44
           },
           {
            "form_name":"TmxGuarantorChecklist{ProductChecklistId:45}",
            "name":"WatchDog Document",
            "required":false,
            "ProductChecklistId":45
       }]
            if(guarantorData.TmxGuarantor.TmxGuarantorChecklist && guarantorData.TmxGuarantor.TmxGuarantorChecklist.length>0){
            guarantorData.TmxGuarantor.TmxGuarantorChecklist.forEach(element => {
                var check = guarantorChecklists.filter(obj => obj.ProductChecklistId==element.ProductChecklistId)[0];
                if(check){
                if(element.AttachmentURL)
                {
                    check.value = element.AttachmentURL;
                }
                else if(element.Attachment && element.value && element.value.includes('ignore')){
                    if(!element.Attachment.includes('data:')){
                    if (element.MimeType=="image/png" && element.Attachment!='') {
                        element.Attachment = 'data:image/jpeg;base64,' + element.Attachment;
                    }
                    else  if (element.MimeType=="application/pdf" && element.Attachment!='') {
                        element.Attachment = 'data:application/pdf;base64,' + element.Attachment;
                    }
                    else  if (element.MimeType=="application/xlsx" && element.Attachment!='') {
                        element.Attachment = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + element.Attachment;
                    }
                    else  if (element.MimeType=="image/tiff" && element.Attachment!='') {
                        element.Attachment = 'data:image/tiff;base64,' + element.Attachment;
                    }
                    else  if (element.MimeType=="application/msword" && element.Attachment!='') {
                        element.Attachment = 'data:application/msword;base64,' + element.Attachment;
                    }
                    }
                check.value = element.Attachment;
                check.Attachment = check.value;
            }
        }
            });
        
        }
            $scope.vm = {};
            $scope.vm.lookup = {};
            $scope.vm.guarantorData = guarantorData;
            $scope.vm.RoleId = RoleId;
            $scope.vm.fieldsMandatory = true;
            $scope.vm.guarantorChecklists = guarantorChecklists;
            $scope.showOk = true;
            $scope.showAdd = showAddButton;
            $scope.ClientID = ClientID;
            $scope.monthlyPayment = 0;
            $scope.CurrentDate = new Date();
            $scope.MaxHiringDateInPreviousJob = new Date();
            $scope.guarantorTabEditPrivilege = guarantorTabEditPrivilege;
            $scope.guarantorTabDeletePrivilege = guarantorTabDeletePrivilege;
            $scope.showJordanEgyptSection = false;
            $scope.showLebanonSection = false;
            $scope.showUbankSection = false;
            $scope.umeployedOrPeddler = false; 
            $scope.disableSpouseAndChildrenDetail = true;
            $scope.spousenatureOfProfessionRequired = false;
            $scope.requireSpouseAndChildrenDetail = false;
            $scope.disableBusinessDetail = true;
            $scope.disablePartnershipDetail = true;
            $scope.disablePartnershipDetail2 = false;
            $scope.disableContractDuration = true;
            $scope.disableEmploymentDetail = true;
            $scope.disableOtherDetail = true;
            $scope.disbaleOtherEmployeeDetail = true;
            $scope.disableOtherOccupationDetail = true;
            $scope.disableBusinessInformationDetail = true;
            $scope.disableSecondaryBusinessInfo = true;
            $scope.disbaleSBPartnerDetail = true;
            $scope.disableSpouseBusinessInformation = true;
            $scope.disableSpouseEmploymentInformation = true;
            $scope.disbaleSpouseBussPercentChange = true;
            $scope.disableKinshipDetails = true;
            $scope.disableContractDurationSE = true;
            $scope.natureOfProfessionRequired = false;
            $scope.disableRelationTable = false;
            $scope.RelationWithBanksAndFinancialInstitutions = false;
            $scope.disableOtherReligion = true;
            $scope.showTranslationButton = false;
            $scope.disableBeneficialOwnerReason = true;

            $scope.disableBusInfoBussPremisisStatus = true;
            $scope.disableSecBusInfoBussPremises = true;
            $scope.disableSpouseBussInfoBussPremises = true;
            var culture = localStorage.getItem('culture');
            $scope.direction = culture == "ar" ? "rtl" : "ltr";

            function scopeVarDeclaration() {
                if (!$scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail = [{}];
                }
                if (!$scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail = [{}];
                }

                if (!$scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail = [{}];
                }

                if (!$scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping || !$scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping.length) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping = [{}];
                }
                if (!$scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxAddress) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxAddress = {};
                }

                if (!$scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxPersonAddressContact || !$scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxPersonAddressContact.length) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxPersonAddressContact = [{}];
                }


                if (!$scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseEmploymentInformation) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseEmploymentInformation = {};
                }

                if (!$scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation = {};
                }

                if (!$scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail = [{}];
                }

                if(!$scope.vm.guarantorData.TmxGuarantor.TmxAdditionalMobile){
                    $scope.vm.guarantorData.TmxGuarantor.TmxAdditionalMobile = [{}];
                }

            }


		////////////////////////Business premises Status Change
            $scope.bussInfoBussPremisisChange = function (bussPremisis) {
                if(bussPremisis)
                {
                var HiddenValue = lookupService.getLookupById(bussPremisis).HiddenValue;
                if (LkpHiddenValue.lebHiddenValue.businessPremisesOwnership == HiddenValue) { //Ownership 
                    $scope.disableBusInfoBussPremisisStatus = true;
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].RemainingPeriodForOccupyingBusinessPremises = "";
                }
                else {
                    $scope.disableBusInfoBussPremisisStatus = false;
                }
            }
                else
                {
                    $scope.disableBusInfoBussPremisisStatus = true;
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].RemainingPeriodForOccupyingBusinessPremises = "";
                }
                
            }

            $scope.SecBussInfoBussPremisisChange = function (bussPremisis) {
                if(bussPremisis){
                var HiddenValue = lookupService.getLookupById(bussPremisis).HiddenValue;
                if (LkpHiddenValue.lebHiddenValue.businessPremisesOwnership == HiddenValue) { //Ownership
                    $scope.disableSecBusInfoBussPremises = true;
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].TechnicalExperience = "";
                }
                else {
                    $scope.disableSecBusInfoBussPremises = false;

                }
            }
            else
            {
            $scope.disableSecBusInfoBussPremises = true;
            $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].TechnicalExperience = "";
            }
            }

            $scope.SpouseBussPremisisChange = function (bussPremisis) {
                if(bussPremisis && !isNaN(bussPremisis)){
                var HiddenValue = lookupService.getLookupById(bussPremisis).HiddenValue;
                if (LkpHiddenValue.lebHiddenValue.businessPremisesOwnership == HiddenValue) { //Ownership
                    $scope.disableSpouseBussInfoBussPremises = true;
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.TechnicalExperience = "";
                }
                else {
                    $scope.disableSpouseBussInfoBussPremises = false;

                }
            }
            else
            {
                $scope.disableSpouseBussInfoBussPremises = true;
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.TechnicalExperience = "";
            }
            }

            $scope.deleteGuarantorLoan = function (index) {
                guarantorData.TmxGuarantor.TmxGuarantorLoanDetail.splice(index, 1);
            }

            $scope.deleteGuarantee = function (index) {
                guarantorData.TmxGuarantor.TmxGuarantorGuaranteeDetail.splice(index, 1);
            }

            $scope.calculateAge = function (dateString) {

                var today = new Date();
                var birthDate = new Date(dateString);
                var age = today.getFullYear() - birthDate.getFullYear();
                var m = today.getMonth() - birthDate.getMonth();
                if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }
                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.PersonAge = age;
                $scope.formatDate=tmxUtility.formatDateForCompany;
            }

		//Religion Change
            $scope.religionOther = function (religion) {
                if (exists(religion)) {
                    var HiddenValue = lookupService.getLookupById(religion).HiddenValue;
                    if (LkpHiddenValue.ubankHiddenValue.otherReligion == HiddenValue) //Religion Other 
                        $scope.disableOtherReligion = false;
                }
                else {
                    $scope.disableOtherReligion = true;
                    $scope.vm.guarantorData.TmxGuarantor.OtherReligionUdf = "";
                }
            }

		//Additional Role Change
            $scope.additionalRoleChange = function (additionalRole) {
                if (exists(additionalRole)) {
                    var HiddenValue = lookupService.getLookupById(additionalRole).HiddenValue;
                    if (LkpHiddenValue.lebHiddenValue.beneficialOwnerAdditionalRole == HiddenValue) //Beneifical Owner or Guarantor 
                        $scope.disableBeneficialOwnerReason = false;
                }
                else {
                    $scope.disableBeneficialOwnerReason = true;
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.ReasonOfBeneficialOwner = "";
                }
            }


		//Civil Status Change
            $scope.civilStatusChange = function (PersonMaritalStatusLkp) {
                if (exists(PersonMaritalStatusLkp)) {
                    var HiddenValue = lookupService.getLookupById(PersonMaritalStatusLkp).HiddenValue;
                    if (LkpHiddenValue.lebHiddenValue.PersonMaritalStatusLkp == HiddenValue) //Civil Staus Married
                    {
                        $scope.disableSpouseAndChildrenDetail = false;
                        $scope.requireSpouseAndChildrenDetail = true;
                    }
                    else if (LkpHiddenValue.lebHiddenValue.PersonMaritalStatusUnregisteredLkp == HiddenValue) {
                        $scope.disableSpouseAndChildrenDetail = false;
                        $scope.requireSpouseAndChildrenDetail = false;
                    }
                    else {
                        $scope.disableSpouseAndChildrenDetail = true;
                        $scope.requireSpouseAndChildrenDetail = false;
                        $scope.disableSpouseEmploymentInformation = true;
                        $scope.disableSpouseBusinessInformation = true;

                        RemoveSpouseAndChildrenDetails();
                    }

                }
                else{
                    $scope.disableSpouseAndChildrenDetail = true;
                    $scope.requireSpouseAndChildrenDetail = false;
                    $scope.disableSpouseEmploymentInformation = true;
                    $scope.disableSpouseBusinessInformation = true;

                    RemoveSpouseAndChildrenDetails();
                }
            }

            function RemoveSpouseAndChildrenDetails() {
                if($scope.vm.guarantorData.TmxGuarantor && $scope.vm.guarantorData.TmxGuarantor.TmxPerson) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseFirstName = undefined;
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseFatherName = undefined;
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseMaidenLastName = undefined;
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.MotherInLawFirstName = undefined;
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.MotherInLawFathersName = undefined;
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.MotherInLawLastName = undefined;
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseOccupationalStatusLkp = null;
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseNatureOfProfessionLkp = null;
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseTotalIncome = 0;
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.FamilyChildrenCount = 0;
                    if( $scope.GuarantorDetailDialogController &&  $scope.GuarantorDetailDialogController.dialogForm) {
                        $scope.GuarantorDetailDialogController.dialogForm.SpouseOccupationalStatus.$setViewValue("","");
                        $scope.GuarantorDetailDialogController.dialogForm.SpouseOccupationalStatus.$commitViewValue();
                        $scope.GuarantorDetailDialogController.dialogForm.SpouseNatureOfProfession.$setViewValue("","");
                        $scope.GuarantorDetailDialogController.dialogForm.SpouseNatureOfProfession.$commitViewValue();
                    }
                    $scope.spouseOccupationChange(undefined);
                }
            }

		//Company life cycle calculation Secondary business information
            $scope.calCompCycleSecondary = function (noOfBussYears,change) {
                if(noOfBussYears){
                if (noOfBussYears >= 0 && noOfBussYears < 1) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].BusinessNature = "Start-up";
                }
                else if(noOfBussYears >= 1) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].BusinessNature = "Existing";
                }
                else
                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].BusinessNature = "";
                }
                else if(noOfBussYears==undefined && change)
                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].BusinessNature = "Start-up";
                else if(noOfBussYears==0)
                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].BusinessNature = "Start-up";
                else
                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].BusinessNature = "";
            }

		//Company life cycle calculation business information
            $scope.calCompCycle = function (noOfBussYears,change) {
                if(noOfBussYears){
                if (noOfBussYears >= 0 && noOfBussYears < 1) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].CompanyLifeCycle = "Start-up";
                }
                else if(noOfBussYears>=1){
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].CompanyLifeCycle = "Existing";
                }
                else
                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].CompanyLifeCycle = "";
                }
                else if(noOfBussYears==undefined && change)
                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].CompanyLifeCycle = "Start-up";
                else if(noOfBussYears==0)
                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].CompanyLifeCycle = "Start-up";
                else
                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].CompanyLifeCycle = "";
            }

		//Company life cycle calculation Spouse business information
            $scope.calCompCycleSpouse = function (noOfBussYears, change) {
                if(noOfBussYears){
                if (noOfBussYears >= 0 && noOfBussYears < 1) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.BusinessNature = "Start-up";
                }
                else if(noOfBussYears>=1){
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.BusinessNature = "Existing";
                }
                else {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.BusinessNature = "";
                }
                }
                else if(noOfBussYears==undefined && change)
                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.BusinessNature = "Start-up";
                else if(noOfBussYears==0)
                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.BusinessNature = "Start-up";
                else
                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.BusinessNature = "";
            }

		//Occupation Type Change
            $scope.occupationTypeChange = function (occupationType) {
                if (exists(occupationType)) {
                    var HiddenValue = lookupService.getLookupById(occupationType).HiddenValue;
                    if (LkpHiddenValue.lebHiddenValue.selfEmployedOccupationType == HiddenValue) //Occupation Type Self Employed
                    {
                        $scope.disableBusinessDetail = false;
                        $scope.disableEmploymentDetail = true;
                    }
                    else if (LkpHiddenValue.lebHiddenValue.partTimeOccupationType == HiddenValue || LkpHiddenValue.lebHiddenValue.fullTimeOccupationType == HiddenValue || LkpHiddenValue.lebHiddenValue.retiredOccupationType == HiddenValue) //Occupation Type - part time, full time, retired
                    {
                        //$scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].BusinessPremisesStatus = null;
                        $scope.disableEmploymentDetail = false;
                        $scope.disableBusinessDetail = true;
                    }
                    else {
                        $scope.disableEmploymentDetail = true;
                        $scope.disableBusinessDetail = true;
                        //$scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].BusinessPremisesStatus = null;
                    }
                    if(LkpHiddenValue.lebHiddenValue.unEmployedOccupationType == HiddenValue){
                        $scope.natureOfProfessionRequired = false;
                        $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].BusinessPremisesStatus = null;
                    }
                    else
                    {
                        $scope.natureOfProfessionRequired = true;
                    }
                    if(exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.IsPeddler)){
                        var peddlerHiddenValue = lookupService.getLookupById($scope.vm.guarantorData.TmxGuarantor.TmxPerson.IsPeddler).HiddenValue;
                    }
                    if(LkpHiddenValue.lebHiddenValue.unEmployedOccupationType == HiddenValue)
                    $scope.umeployedOrPeddler = false;
                    else if(exists(peddlerHiddenValue) && LkpHiddenValue.lebHiddenValue.peddlerYesValue == peddlerHiddenValue)
                    $scope.umeployedOrPeddler =  false;
                    else
                    $scope.umeployedOrPeddler = true;
                    
                    if($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].NumberOfYearOfExperienceInTheField>=0)
                    $scope.calCompCycle($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].NumberOfYearOfExperienceInTheField,false);
                }
                else
                {
                    if(exists(peddlerHiddenValue) && LkpHiddenValue.lebHiddenValue.peddlerYesValue == peddlerHiddenValue)
                    $scope.umeployedOrPeddler =  false;
                    else
                    $scope.umeployedOrPeddler = false;
                    $scope.natureOfProfessionRequired = false;
                    $scope.disableBusinessDetail = true;
                    $scope.disableEmploymentDetail = true;
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].BusinessPremisesStatus = null;
                }

            }
            $scope.peddlerChange = function (peddlerValue) {
                if (exists(peddlerValue)) {
                    var peddlerHiddenValue = lookupService.getLookupById(peddlerValue).HiddenValue;
                    if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.PersonProfessionTypeLkp))
                        var unemployed = lookupService.getLookupById($scope.vm.guarantorData.TmxGuarantor.TmxPerson.PersonProfessionTypeLkp).HiddenValue;
                    if (unemployed && LkpHiddenValue.lebHiddenValue.unEmployedOccupationType == unemployed) {
                        $scope.umeployedOrPeddler = false;
                    }
                    else if (exists(peddlerHiddenValue) && LkpHiddenValue.lebHiddenValue.peddlerYesValue == peddlerHiddenValue) {
                        $scope.umeployedOrPeddler = false;
                    }
                    else
                        $scope.umeployedOrPeddler = true;
                }
                else if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.PersonProfessionTypeLkp))
                    {var unemployed = lookupService.getLookupById($scope.vm.guarantorData.TmxGuarantor.TmxPerson.PersonProfessionTypeLkp).HiddenValue;
                if (unemployed && LkpHiddenValue.lebHiddenValue.unEmployedOccupationType == unemployed) {
                    $scope.umeployedOrPeddler = false;
                }
                }
                else
                    $scope.umeployedOrPeddler = false;
            }
		//Percentage Ownership field Change
            $scope.percentageOwnershipChange = function (percentageOwnership) {
                if (exists(percentageOwnership)) {
                    if (percentageOwnership > 0 && percentageOwnership < 100) //Occupation Type Self Employed
                    {
                        $scope.disablePartnershipDetail = false;
                    }
                    else {
                        $scope.disablePartnershipDetail = true;
                    }
                }
            }

		//Contract Type Field Change
            $scope.contractTypeChange = function (contractType) {
                if (exists(contractType)) {
                    var HiddenValue = lookupService.getLookupById(contractType).HiddenValue;
                    if (LkpHiddenValue.lebHiddenValue.limitedContractType == HiddenValue) //if contract type is limited
                    {
                        $scope.disableContractDuration = false;
                    }
                    else {
                        $scope.disableContractDuration = true;
                    }
                }
                else
                $scope.disableContractDuration = true;
            }

		//Other Occupation change
            $scope.otherOccupationChange = function (otherOccupation) {
                if (exists(otherOccupation)) {
                    var HiddenValue = lookupService.getLookupById(otherOccupation).HiddenValue;
                    if (LkpHiddenValue.lebHiddenValue.yesLkp == HiddenValue) {
                        $scope.disableOtherDetail = false;
                    }
                    else {
                        $scope.disableOtherDetail = true;
                    }
                }
                else
                $scope.disableOtherDetail = true;
            }

		/****************Other Occupation***********************/
            $scope.otherEmployeeDetail = function (contractType) {
                if (exists(contractType)) {
                    var HiddenValue = lookupService.getLookupById(contractType).HiddenValue;
                    if (LkpHiddenValue.lebHiddenValue.limitedContractType == HiddenValue) //if contract type is limited(yes)
                    {
                        $scope.disbaleOtherEmployeeDetail = false;
                    }
                    else {
                        $scope.disbaleOtherEmployeeDetail = true;
                    }
                }
                else
                $scope.disbaleOtherEmployeeDetail = true;
            }

		/****************Spouse Employment - Contract Type***********************/
            $scope.changeContractTypeSE = function (contractTypeSE) {
                if (exists(contractTypeSE)) {
                    var HiddenValue = lookupService.getLookupById(contractTypeSE).HiddenValue;
                    if (LkpHiddenValue.lebHiddenValue.limitedContractType == HiddenValue) //if contract type is limited(yes)
                    {
                        $scope.disableContractDurationSE = false;
                    }
                    else {
                        $scope.disableContractDurationSE = true;
                    }
                }
            }

		/****************Other Occupation yes and occupation staus employed***********************/
            $scope.otherOccupationStatus = function (otherOccupationStatus) {
                if (exists(otherOccupationStatus)) {
                    var HiddenValue = lookupService.getLookupById(otherOccupationStatus).HiddenValue;
                    if (LkpHiddenValue.lebHiddenValue.partTimeOccupationType == HiddenValue || LkpHiddenValue.lebHiddenValue.fullTimeOccupationType == HiddenValue)//full time, part time
                    {
                        $scope.disableOtherOccupationDetail = false;
                        $scope.disableBusinessInformationDetail = true;
                    }
                    else if (LkpHiddenValue.lebHiddenValue.selfEmployedOccupationType == HiddenValue) {
                        $scope.disableBusinessInformationDetail = false;
                        $scope.disableOtherOccupationDetail = true;
                    }
                    else {
                        $scope.disableOtherOccupationDetail = true;
                        $scope.disableBusinessInformationDetail = true;
                    }
                    if($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].CurrentBusinessExperience>=0)
                    {
                        $scope.calCompCycleSecondary($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].CurrentBusinessExperience,false)
                    }
                }
                else
                {
                    $scope.disableOtherOccupationDetail = true;
                    $scope.disableBusinessInformationDetail = true;
                }
            }

		/****************Degree of kinship***********************/
            $scope.kinshipChange = function (kinship) {
                if (exists(kinship)) {
                    var HiddenValue = lookupService.getLookupById(kinship).HiddenValue;
                    if (LkpHiddenValue.lebHiddenValue.nonKinship == HiddenValue)//Occupatoin type part time and full time
                    {
                        $scope.disableKinshipDetails = true;
                    }
                    else {
                        $scope.disableKinshipDetails = false;
                    }
                }
            }

		/****************Secondary Business Info- Percent change***********************/
            $scope.sbPercentageChange = function (percentageOwnership) {
                if (exists(percentageOwnership)) {
                    if (percentageOwnership > 0 && percentageOwnership < 100) {
                        $scope.disbaleSBPartnerDetail = false;
                    }
                    else {
                        $scope.disbaleSBPartnerDetail = true;
                    }
                }
            }


		/****************Spouse Occupation Status Change***********************/
            $scope.spouseOccupationChange = function (spouseOccupation) {
                if (exists(spouseOccupation)) {
                    var HiddenValue = lookupService.getLookupById(spouseOccupation).HiddenValue;
                    if (LkpHiddenValue.lebHiddenValue.partTimeOccupationType == HiddenValue || LkpHiddenValue.lebHiddenValue.fullTimeOccupationType == HiddenValue)//Occupatoin type part time and full time
                    {
                        $scope.disableSpouseEmploymentInformation = false;
                        $scope.disableSpouseBusinessInformation = true;

                    }
                    else if (LkpHiddenValue.lebHiddenValue.selfEmployedOccupationType == HiddenValue)//occupation type self employed
                    {
                        $scope.disableSpouseBusinessInformation = false;
                        $scope.disableSpouseEmploymentInformation = true;
                    }
                    else {
                        $scope.disableSpouseEmploymentInformation = true;
                        $scope.disableSpouseBusinessInformation = true;
                    }
                    if(LkpHiddenValue.lebHiddenValue.unEmployedOccupationType == HiddenValue){
                        $scope.spousenatureOfProfessionRequired = false;
                    }
                    else
                    $scope.spousenatureOfProfessionRequired = true;
                    if($scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.CurrentBusinessExperience>=0){
                        $scope.calCompCycleSpouse($scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.CurrentBusinessExperience,false);
                    }
                }
                else
                $scope.spousenatureOfProfessionRequired = false;
            }

		/****************Spouse Business Inf***********************/
            $scope.disbaleSpouseBussPercent = function (spousePercentage) {
                if (exists(spousePercentage)) {
                    if (spousePercentage > 0 && spousePercentage < 100) {
                        $scope.disbaleSpouseBussPercentChange = false;
                    }
                    else {
                        $scope.disbaleSpouseBussPercentChange = true;
                    }
                }
            }

		/****************Sum of Net Income***********************/
            $scope.netIncomeCalculate = function (arg1, arg2, arg3, arg4) {
                let num1 = isNaN(Number(arg1)) ? 0 : Number(arg1);
                let num2 = isNaN(Number(arg2)) ? 0 : Number(arg2);
                let num3 = isNaN(Number(arg3)) ? 0 : Number(arg3);
                let num4 = isNaN(Number(arg4)) ? 0 : Number(arg4);

                var sum = num1 + num2 + num3 + num4;
                if (exists(sum)) {
                    return sum;
                }
                else {
                    return 0;
                }
            }

		/****************Maximum Bill Capacity***********************/
            $scope.maxBillCapacity = function (netIncome) {
                if (exists(netIncome)) {
                    return netIncome * 0.35;
                }
                else {
                    return 0;
                }
            }

		/****************Account in Bank***********************/
            $scope.accInBank = function (account) {
                if (exists(account)) {
                    var HiddenValue = lookupService.getLookupById(account).HiddenValue;
                    if (LkpHiddenValue.lebHiddenValue.yesLkp == HiddenValue)//Occupatoin type part time and full time
                    {
                        $scope.disableRelationTable = true;
                    }
                    else {
                        $scope.disableRelationTable = false;
                    }
                }
            }

            $scope.calculateCurrentTenure = function (dateString) {

                if (dateString) {
                    $scope.MaxHiringDateInPreviousJob = new Date(dateString);
                }
                else {
                    $scope.MaxHiringDateInPreviousJob = undefined;
                }


                var today = new Date();
                var joinDate = new Date(dateString);
                if (joinDate < today) {
                    var tenure = today.getFullYear() - joinDate.getFullYear();
                    var m = today.getMonth() - joinDate.getMonth();
                    if (m < 0 || (m === 0 && today.getDate() < joinDate.getDate())) {
                        tenure--;
                    }
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail[0].YearsofEngagement = tenure;
                }
                else {
                    ToastService.showCustomToast("error", "Hire Date Must not be Greater Than Current Date");
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail[0].EmployedSince = "";
                }
            }

            $scope.calculatePreviousTenure = function (join, resign) {

                if (join) {
                    $scope.MinResignDateFromPreviousJob = new Date(join);
                }
                else {
                    $scope.MinResignDateFromPreviousJob = undefined;
                }

                if (resign) {
                    $scope.MinHiringDateInCurrentJob = new Date(resign);
                }
                else {
                    $scope.MinHiringDateInCurrentJob = undefined;
                }

                var joinDate = new Date(join);
                var resignDate = new Date(resign);
			// if(resignDate>joinDate){
                var tenure = resignDate.getFullYear() - joinDate.getFullYear();
                var m = resignDate.getMonth() - joinDate.getMonth();
                if (m < 0 || (m === 0 && resignDate.getDate() < joinDate.getDate())) {
                    tenure--;
                }
                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail[0].PreviousEmployerYearsOfEngagement = tenure;
			//}
			// else{
			// 	ToastService.showCustomToast("error","Hire Date Must not be Greater Than Resign Date");
			// 	$scope.vm.guarantorData.TmxGuarantor.TmxPerson.DateOfHiringInPreviousJob="";
			// 	// $scope.vm.guarantorData.TmxGuarantor.TmxPerson.DateOfResignFromPreviousJob="";

			// }
            }

            $scope.SearchVisibleValue = function (objArray, LookupID) {
                var obj = $filter('filter')(objArray, { LookupId: parseInt(LookupID) }, true)[0];
                if (obj) {
                    return obj.VisibleValue;
                }
            }           

            $scope.SumValues = function (value1, value2) {
                var result = value1 + value2;
                return result;
            }

            $scope.SubValues = function (value1, value2) {
                var result = value1 - value2;
                return result;
            }

            $scope.CalculateTotalIncome = function (guarantorObj) {
                if ($scope.isVitasEgyptTenant)
                    return $scope.SubValues(guarantorObj.TotalIncome, guarantorObj.PersonalExpensesAmount)
                else
                    return $scope.SubValues(guarantorObj.TotalIncome, guarantorObj.TotalExpenseAmount)
            }

            $scope.calculateDBR = function (guarantorObj) {
                var value1 = guarantorObj.TotalLoanAmount;
                var value2 = 1;
                if ($scope.isVitasEgyptTenant)
                    value2 = guarantorObj.TotalNetIncome;
                else
                    value2 = guarantorObj.TotalIncome;
                var result = value1 / value2;
                var dbr = Math.round((result + 0.00001) * 100) / 100;
                if ($scope.isVitasEgyptTenant) {
                    dbr = dbr * 100;
                }
                return dbr;
            }

            $scope.calculateNewLoanDBR = function (guarantorObj) {
                var value1 = guarantorObj.TotalLoanAmount;
                var value2 = 1;
                if ($scope.isVitasEgyptTenant)
                    value2 = guarantorObj.TotalNetIncome;
                else
                    value2 = guarantorObj.TotalIncome;
                var installmentAmount = Number(guarantorData.InstallmentAmount);
                var numinator = value1 + installmentAmount;
                var result = numinator / value2;
                var dbr = Math.round((result + 0.00001) * 100) / 100;
                if ($scope.isVitasEgyptTenant) {
                    dbr = dbr * 100;
                }
                return dbr;
            }


            $scope.calculateDBRGuarantor = function (value1, value2, value3) {
                var result = value1 + value2;
                result = result / value3;
                var dbr = Math.round((result + 0.00001) * 100) / 100;
                if ($scope.isVitasEgyptTenant) {
                    dbr = dbr * 100;
                }
                return dbr;
            }

            $scope.filterCityByLookup = function (region) {
                if (region) {
                    lookupService.getByTypeAndParent('City', region).then(function (response) {
                        $scope.vm.lookup.cityRegionLkp = response;
                    });
                }
                else {
                    $scope.vm.lookup.cityRegionLkp = [];
                    if ($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxAddress.AddressLine3) {
                        $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxAddress.AddressLine3 = null;
                    }
                }
            }
            $scope.filterAreaByLkp = function (city) {
                if (city) {
                    lookupService.getByTypeAndParent('Area', city).then(function (response) {
                        $scope.vm.lookup.areaCityLkp = response;
                    });
                }
                else {
                    $scope.vm.lookup.areaCityLkp = [];
                    if ($scope.vm.guarantorData.TmxGuarantor.VillageAreaUdf) {
                        $scope.vm.guarantorData.TmxGuarantor.VillageAreaUdf = null;
                    }
                }
            }

            $scope.filterGuarantorActivitiesBySectorsLookup = function (sector) {
                if (sector) {
                    lookupService.getByTypeAndParent('Activities', sector).then(function (response) {
                        $scope.vm.lookup.GuarantorActivitiesLkp = response;
                    });
                }
                else {
                    $scope.vm.lookup.GuarantorActivitiesLkp = [];
                    if ($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness) {
                        $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = null;
                    }
                    if ($scope.vm.guarantorData.TmxGuarantor.ClientActivities) {
                        $scope.vm.guarantorData.TmxGuarantor.ClientActivities = null;
                    }
                }
            }

            $scope.IsPEPSChange = function (lookupId) {
                if(lookupId) {
                    var HiddenValue = lookupService.getLookupById(lookupId).HiddenValue;
                    if(LkpHiddenValue.lebHiddenValue.yesLkp == HiddenValue) {
                        $scope.PositionRequired = true;
                    }
                    else {
                        $scope.PositionRequired = false;
                    }
                }
                else {
                    $scope.PositionRequired = false;
                }
            }

            $scope.DocumentTypeChange = function (lookupId) {
                if(lookupId) {
                    var HiddenValue = lookupService.getLookupById(lookupId).HiddenValue;
                    if(LkpHiddenValue.jorHiddenValue.IDTypeArmyCard == HiddenValue) {
                        $scope.MilitaryPositionRequired = true;
                    }
                    else {
                        $scope.MilitaryPositionRequired = false;
                    }
                }
                else {
                    $scope.MilitaryPositionRequired = false;
                }
            }

            $scope.getLookupVisibleValue = function (lookupId) {
                var lookup = lookupService.getLookupById(lookupId);
                if (exists(lookup)) {
                    return lookup.VisibleValue;
                }
                return "";
            }
            $scope.onImageClick = function (value, field) {
                $scope.previewImageUrl = value;
                $scope.previewImageField = field;
                $scope.openImageWindow();
            }
    
            $scope.openImageWindow = function () {
                //var html = '<img style="width: 100%;" src="'+vm.previewImageUrl+'" />';
                //var uri = "data:text/html," + encodeURIComponent(html);
                var images = [];
                var notAllowedFormats = ['.tiff', '.tif', 'data:image/tiff;base64'];
                var previewIndex = 0;
                for (var i = 0; i < $scope.vm.guarantorChecklists.length; i++) {
                    var value = $scope.vm.guarantorChecklists[i].Attachment ? $scope.vm.guarantorChecklists[i].Attachment : $scope.vm.guarantorChecklists[i].value;
                    if (value && !value.includes(notAllowedFormats[0]) && !value.includes(notAllowedFormats[1]) && !value.includes(notAllowedFormats[2])) {
                        if ($scope.vm.guarantorChecklists[i].ProductChecklistId == $scope.previewImageField.ProductChecklistId) {
                            previewIndex = images.length;
                        }
                        var image = {
                            src: value,
                            label: $scope.vm.guarantorChecklists[i].name
                        }
                        images.push(image);
                    }
                }
                localStorage.setItem('imagePreview', JSON.stringify(images));
                //var html = vm.previewImageUrl;
                // + '&title=' + encodeURIComponent($scope.page.fieldMap.primaryKey.tf146.value)
                var uri = "common/directives/dynamicpage/imagePreview.html?img=" + encodeURIComponent(previewIndex);
                var newwindow = window.open(uri, 'Image Preview ' + imagePreviewPopups.length, 'height=900,width=900');
                imagePreviewPopups.push(newwindow);
            }
            
            $scope.dataManipulate = function () {
                if ($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonNationalIdentifier) {
                    angular.forEach($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonNationalIdentifier, function (item) {
                        if (item.NationalIdentifierValue && (!angular.isDefined(item.NationalIdTypeLkp) || item.NationalIdTypeLkp == 0))
                            item.NationalIdTypeLkp = 5;
                    })
                }
                if ($scope.vm.IDSerialNumber) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonNationalIdentifier.push({
                        'NationalIdentifierValue': $scope.vm.IDSerialNumber,
                        'NationalIdTypeLkp': 4
                    })
                }
                if($scope.vm.guarantorChecklists){
                    $scope.vm.guarantorChecklists.forEach(element => {
                        if(element.Attachment){
                            element.ProductChecklistId = element.ProductChecklistId;
                            element.MimeType = "";
                        if (element.Attachment.includes('data:image/jpeg;base64')) {
                            element.MimeType = "image/png";
                        }
                        else if (element.Attachment.includes('data:application/pdf;base64')) {
                            element.MimeType = "application/pdf";
                        }
                        else if (element.Attachment.includes('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64')) {
                            element.MimeType = "application/xlsx";
                        }
                        else if (element.Attachment.includes('data:image/tiff;base64')) {
                            element.MimeType = "image/tiff";
                        }
                        else if (element.Attachment.includes('data:application/msword;base64')) {
                            element.MimeType = "application/msword";
                        }
                        element.Attachment = element.Attachment.replace('data:image/jpeg;base64,', '').replace('data:application/pdf;base64,', '').replace('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,', '').replace('data:image/tiff;base64,', '').replace('data:application/msword;base64,', '');
                        if($scope.vm.guarantorData.TmxGuarantor.TmxGuarantorChecklist && $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorChecklist.length>0)
                            {
                                var foundChecklist = $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorChecklist.filter(obj=>obj.ProductChecklistId== element.ProductChecklistId)[0];
                            }
                                if(foundChecklist){
                               // $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorChecklist.filter(obj=>obj.ProductChecklistId== element.ProductChecklistId)[0] = element;
                                //var attachment = $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorChecklist.filter(obj=>obj.ProductChecklistId== element.ProductChecklistId)[0].Attachment;
                                foundChecklist.Attachment = element.Attachment;
                                foundChecklist.AttachmentURL = null;
                                var ind = $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorChecklist.indexOf(foundChecklist);
                                $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorChecklist.splice(ind,1);
                                $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorChecklist.push(element);
                            }
                            else
                            $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorChecklist.push(element);
                        }
                            else if(element.value==""){
                                if($scope.vm.guarantorData.TmxGuarantor.TmxGuarantorChecklist && $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorChecklist.length>0){
                            var foundChecklist = $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorChecklist.filter(obj=>obj.ProductChecklistId== element.ProductChecklistId)[0];
                            if(foundChecklist){
                                var ind = $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorChecklist.indexOf(foundChecklist);
                                $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorChecklist.splice(ind,1);
                            }
                        }
                        }
                    });
                }
            };
            $scope.ok = function (form) {
                form.$submitted = true;
                if (form.$valid || !$scope.vm.fieldsMandatory) {
                    $scope.dataManipulate();
                    $mdDialog.hide();
                }

                else {
                    ToastService.showCustomToast("error", "Form Invalid.");
                }

            };
            $scope.add = function (form) {
                $scope.vm.ClientID = $scope.ClientID;

                form.$submitted = true;
                if (form.$valid || !$scope.vm.fieldsMandatory) {
                    $scope.dataManipulate();
                    $mdDialog.hide($scope.vm);
                }

                else {
                    ToastService.showCustomToast("error", $filter('translate')("FillRequiredFields"));
                }


            };
            $scope.cancel = function () {
                $mdDialog.hide();
            };

            $scope.translateValues = function () {
                var DictAddress = $scope.vm.guarantorData.TmxGuarantor.TmxPerson.CustPR || false;
                var Suburb = tmxUtility.getPropertyValue($scope.vm.guarantorData.TmxGuarantor, "TmxPerson.TmxPersonToAddressMapping[0].TmxAddress.CustCaza") || false;
                var body = {
                    "DictAddress": DictAddress ? DictAddress : null,
                    "LocationLookupId": Suburb ? Suburb : null
                }

                if (DictAddress || Suburb) {
                    tmxResource("Integration").getByAction("TranslateModelValues", false, 'post', body).then(function (response) {
                        if (response.status.code == 200) {
                            $scope.vm.guarantorData.TmxGuarantor.TmxPerson.CustPR = response.data.DictAddress;
                            $scope.vm.guarantorData.TmxGuarantor.TmxPerson.CustPRArabic = response.data.AddressArabic;

                            if (exists(response.data.AddressLocation)) {
                                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxAddress.CustTown = response.data.AddressLocation.City;//tmxUtility.getPropertyValue(lookupService.getLookupById(response.data.AddressLocation.City),"VisibleValue");

                                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxAddress.CustCaza = response.data.AddressLocation.Suburb; //tmxUtility.getPropertyValue(lookupService.getLookupById(response.data.AddressLocation.Suburb),"VisibleValue");

                                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxAddress.CustDistrict = response.data.AddressLocation.Area;//tmxUtility.getPropertyValue(lookupService.getLookupById(response.data.AddressLocation.Area),"VisibleValue");
                            }
                        }
                    });
                }
                else {
                    ToastService.showCustomToast("default", "Please select an address to translate.");
                }
            }


            function calculateTotalLoanAmount() {
                guarantorData.TmxGuarantor.TotalLoanAmount = 0;
                angular.forEach(guarantorData.TmxGuarantor.TmxGuarantorLoanDetail, function (item) {
                    guarantorData.TmxGuarantor.TotalLoanAmount += item.MonthlyLoanAmount;
                });
            }

            function SetupUsingExistingValues() {
                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.PersonMaritalStatusLkp)) {
                    $scope.civilStatusChange($scope.vm.guarantorData.TmxGuarantor.TmxPerson.PersonMaritalStatusLkp);
                }

                //if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].NumberOfYearOfExperienceInTheField)) {
                    $scope.calCompCycle($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].NumberOfYearOfExperienceInTheField,true)
                //}

                //if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.CurrentBusinessExperience)) {
                    $scope.calCompCycleSpouse($scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.CurrentBusinessExperience,true)
                //}

                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.PersonProfessionTypeLkp)) {
                    $scope.occupationTypeChange($scope.vm.guarantorData.TmxGuarantor.TmxPerson.PersonProfessionTypeLkp);
                }

                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail) && exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].GuarantorPercentageOwnership)) {
                    $scope.percentageOwnershipChange($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].GuarantorPercentageOwnership);
                }

                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail) && $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail.length > 0) {
                    $scope.contractTypeChange($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail[0].ContractType);
                }

                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.OtherOccupationLkp)) {
                    $scope.otherOccupationChange($scope.vm.guarantorData.TmxGuarantor.TmxPerson.OtherOccupationLkp);
                }

                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.OeContractType)) {
                    $scope.otherEmployeeDetail($scope.vm.guarantorData.TmxGuarantor.TmxPerson.OeContractType);
                }

                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseEmploymentInformation.ContractType)) {
                    $scope.changeContractTypeSE($scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseEmploymentInformation.ContractType);
                }

                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.OccupationalStatusLkp)) {
                    $scope.otherOccupationStatus($scope.vm.guarantorData.TmxGuarantor.TmxPerson.OccupationalStatusLkp);
                }

                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.DegreeOfKinship)) {
                    $scope.kinshipChange($scope.vm.guarantorData.TmxGuarantor.TmxPerson.DegreeOfKinship);
                }

                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail) && exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].BiBorrowerPercentageOwnership)) {
                    $scope.sbPercentageChange($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].BiBorrowerPercentageOwnership);
                }

                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseOccupationalStatusLkp)) {
                    $scope.spouseOccupationChange($scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseOccupationalStatusLkp);
                }

                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation) && exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.BorrowerPercentageOwnership)) {
                    $scope.disbaleSpouseBussPercent($scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.BorrowerPercentageOwnership);
                }

			// if(exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation) && exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail) && exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail))
			// {
			// 	$scope.netIncomeCalculate($scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.NetProfit,$scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].NetProfit,$scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].BiNetProfit)
			// }

                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].MaximumBillCapacity)) {
                    $scope.maxBillCapacity($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].NetIncome);
                }

                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.AccountInBank)) {
                    $scope.accInBank($scope.vm.guarantorData.TmxGuarantor.TmxPerson.AccountInBank);
                }

                if ($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxAddress && !$scope.isVitasEgyptTenant) {
                    if ($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxAddress.AddressLine2) {
                        $scope.filterCityByLookup($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonToAddressMapping[0].TmxAddress.AddressLine2)
                    }
                }

                if ($scope.vm.guarantorData.TmxGuarantor.TmxPerson && $scope.isVitasEgyptTenant) {
                        $scope.filterCityByLookup($scope.vm.guarantorData.TmxGuarantor.TmxPerson.GovernorateIDUdf)
                }

                if ($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail && $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail.length > 0 && $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail[0].NameOfBusiness) {
                    $scope.filterGuarantorActivitiesBySectorsLookup($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonProfessionDetail[0].NameOfBusiness);
                }

                if (exists($scope.vm.guarantorData.TmxGuarantor.AdditionalRole)) {
                    $scope.additionalRoleChange($scope.vm.guarantorData.TmxGuarantor.AdditionalRole);
                }

                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].BusinessPremisesStatus)) {
                    $scope.bussInfoBussPremisisChange($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].BusinessPremisesStatus)
                }

                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].OtherRemittanceFrequencyType)) {
                    $scope.SecBussInfoBussPremisisChange($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].OtherRemittanceFrequencyType)
                }

                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.BusinessPremisesStatus)) {
                    $scope.SpouseBussPremisisChange($scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.BusinessPremisesStatus)
                }

                //if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.SpouseBusinessInformation.CurrentBusinessExperience)) {
                    $scope.calCompCycleSecondary($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].CurrentBusinessExperience,true)
                //}

                if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].NetProfit) || exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].BiNetProfit) || exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.CENetMonthlySalary) || exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.OeNetMonthlySalary)) {
                    if (!exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail)) {
                        $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail = [];
                        $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0] = {};
                    }

                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].NetIncome = $scope.netIncomeCalculate($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPrimaryBusinessLoanApplicationDetail[0].NetProfit, $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].BiNetProfit, $scope.vm.guarantorData.TmxGuarantor.TmxPerson.CENetMonthlySalary, $scope.vm.guarantorData.TmxGuarantor.TmxPerson.OeNetMonthlySalary);
                }


                if ($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].NetIncome) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.MaximumBillCapacity = $scope.maxBillCapacity($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxSecondaryBusinessLoanApplicationDetail[0].NetIncome);
                }

            }

            function tenantWiseConfiguration() {
                if (LoggedInUserConfigurations) {
                    loggedInTenantName = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'INTEGRATION_TENANT').toLowerCase();
                }

                if (loggedInTenantName == tenants.VITAS || loggedInTenantName == tenants.VITAS_EG) {
                    $scope.showJordanEgyptSection = true;

                    if (loggedInTenantName == tenants.VITAS_EG) {
                        $scope.isVitasEgyptTenant = true;
                    }
                    else if(loggedInTenantName == tenants.VITAS && $scope.vm.RoleId == 39) {
                        $scope.vm.fieldsMandatory = false;
                    }

                    scopeVarDeclaration();
                    SetupUsingExistingValues();
                }

                if (loggedInTenantName == tenants.VITAS_LEB) {
                    $scope.showLebanonSection = true;
                    $scope.showTranslationButton = tmxUtility.checkPermission('TranslateValuesButton', 'View');
                    scopeVarDeclaration();
                    SetupUsingExistingValues();

                }

                if (loggedInTenantName == tenants.UBANK) {
                    $scope.showUbankSection = true;
				// UbankScopeVarDeclaration();

                    if (exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.PersonReligion)) {
                        $scope.religionOther($scope.vm.guarantorData.TmxGuarantor.TmxPerson.PersonReligion);
                    }
                }
            }

		/****************Guarantor Guarantee ***********************/
            $scope.addGuarantorGuaranteeTableDetail = function () {
                $scope.viewGuarantorGuaranteeTableDetail(-1, {}, 'true');
            }

            $scope.viewGuarantorGuaranteeTableDetail = function (index, data, add) {
                var guarantorData = {};
                var showAddButton = false;


                if (add) {
                    showAddButton = true;
                }


                if (index > -1) {
                    guarantorData = $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorGuaranteeDetail[index];
                    showAddButton = false;
                }
                else if (data && Object.keys(data).length) {
                    guarantorData = data;
                    showAddButton = true;
                }

                if ($scope.vm.guarantorData.TmxGuarantor.TmxGuarantorGuaranteeDetail.length == 0) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorGuaranteeDetail = [];
                }

                if ($scope.vm.guarantorData.TmxGuarantor.TmxGuarantorBankDetail.length == 0) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorBankDetail = [];
                }
                if ($scope.vm.guarantorData.TmxGuarantor.TmxGuarantorLoanDetail.length == 0) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorLoanDetail = [];
                }

                $mdDialog.show({
                    controller: 'GuarantorGuaranteeDialogController',
                    controllerAs: 'GuarantorGuaranteeDialogController',
                    locals: { guarantorData: guarantorData, showAddButton: showAddButton, guarantorTabEditPrivilege: $scope.guarantorTabEditPrivilege,direction:$scope.direction },
                    templateUrl: 'app/private/transaction/loan-application/edit/guarantor/html/view-guarantees-gurantor-detail.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    multiple: true


                })
                    .then(function (responseData) {
                        if (responseData) {
                            ($scope.vm.guarantorData.TmxGuarantor.TmxGuarantorGuaranteeDetail).push(responseData.TmxGuarantor.TmxGuarantorGuaranteeDetail);
						//$scope.vm.guarantorData.TmxGuarantor.GuarantorGuaranteeTotalMonthlyPayment += responseData.TmxGuarantor.TmxGuarantorGuaranteeDetail.MonthlyLoanAmount;
                        }
                        $scope.vm.guarantorData.TmxGuarantor.GuarantorGuaranteeTotalMonthlyPayment = 0;
                        $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorGuaranteeDetail.forEach(function (data) {
                            $scope.vm.guarantorData.TmxGuarantor.GuarantorGuaranteeTotalMonthlyPayment += data.MonthlyLoanAmount;
                        })


                    }, function () {

                    });
            }

		/****************Mulitple Mobile Number in Grid***********************/


		// $scope.removeMobileNo = function (index) {
		// 	$scope.vm.guarantorData.TmxGuarantor.TmxPerson.CustMobile.splice(index, 1);
		// }

		// $scope.addMobileNo = function () {
		// 	$scope.vm.guarantorData.TmxGuarantor.TmxPerson.CustMobile.push({ "CustMobileList": "" })
		// }

		/****************Loan Details***********************/
            $scope.addLoanTableDetail = function () {
                $scope.viewLoanTableDetail(-1, {}, 'true');
            }

            $scope.viewLoanTableDetail = function (index, data, add) {
                var guarantorData = {};
                var showAddButton = false;


                if (add) {
                    showAddButton = true;
                }

                if (index > -1) {
                    guarantorData = $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorLoanDetail[index];
                    showAddButton = false;
                }
                else if (data && Object.keys(data).length) {
                    guarantorData = data;
                    showAddButton = true;
                }


                if ($scope.vm.guarantorData.TmxGuarantor.TmxGuarantorLoanDetail.length == 0) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorLoanDetail = [];
                }

                $mdDialog.show({
                    controller: 'GuarantorLoanDialogController',
                    controllerAs: 'GuarantorLoanDialogController',
                    locals: { guarantorData: guarantorData, showAddButton: showAddButton, guarantorTabEditPrivilege: $scope.guarantorTabEditPrivilege, tenantName: loggedInTenantName,direction : $scope.direction },
                    templateUrl: 'app/private/transaction/loan-application/edit/guarantor/html/view-guarantor-loan-detail.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    multiple: true
                })
                    .then(function (responseData) {
                        if (responseData) {
                            ($scope.vm.guarantorData.TmxGuarantor.TmxGuarantorLoanDetail).push(responseData.TmxGuarantor.TmxGuarantorLoanDetail);


						//$scope.vm.guarantorData.TmxGuarantor.TotalLoanAmount += responseData.TmxGuarantor.TmxGuarantorLoanDetail.MonthlyLoanAmount;
                        }
                        $scope.vm.guarantorData.TmxGuarantor.TotalLoanAmount = 0;
                        $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorLoanDetail.forEach(function (data) {
                            $scope.vm.guarantorData.TmxGuarantor.TotalLoanAmount += data.MonthlyLoanAmount;
                        })

                    });
            }

		/****************guarantor ID ***********************/
            $scope.isIDExpiryDateRequiredLeb = function (index) {
                var NationalIdentifierData = $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonNationalIdentifier[index];
                if (exists(NationalIdentifierData.NationalIdTypeLkp)) {
                    var HiddenValue = lookupService.getLookupById(NationalIdentifierData.NationalIdTypeLkp).HiddenValue;
                }
                if (exists(NationalIdentifierData.NationalityLkp)) {
                    //Comparing visible value because hidden value and description is same for all nationalities
                    var NatVisibleValue = $scope.getLookupVisibleValue(NationalIdentifierData.NationalityLkp);
                }
                if (exists(NatVisibleValue) && LkpHiddenValue.lebHiddenValue.Lebanon != NatVisibleValue) //Beneifical Owner or Guarantor 
                    return true;
                else if ((exists(HiddenValue) && LkpHiddenValue.lebHiddenValue.Passport == HiddenValue)) //Beneifical Owner or Guarantor 
                    return true;
                else {
                    return false;
                };
            }

            $scope.addGuarantorIDDetailsTable = function () {
                $scope.viewGuarantorIDDetails(-1, {}, 'true');
            }

            $scope.deleteGurantorDetail = function (index) {
                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonNationalIdentifier.splice(index, 1);
            }

            $scope.viewGuarantorIDDetails = function (index, data, add) {
                var tmxPersonNationalIdentifier = {};
                var showAddButton = false;


                if (add) {
                    showAddButton = true;
                }

                if (index > -1) {
                    tmxPersonNationalIdentifier = $scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonNationalIdentifier[index];
                    showAddButton = false;
                }
                else if (data && Object.keys(data).length) {
                    tmxPersonNationalIdentifier = data;
                    showAddButton = true;
                }

                if ($scope.vm.guarantorData.TmxGuarantor == null) {
                    $scope.vm.guarantorData.TmxGuarantor = {};
                }

                if ($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonNationalIdentifier.length == 0) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPersonNationalIdentifier = [];
                }

                $mdDialog.show({
                    controller: 'GuarantorIDDetailDialogController',
                    controllerAs: 'GuarantorIDDetailDialogController',
                    locals: { TmxPersonNationalIdentifier: tmxPersonNationalIdentifier, showAddButton: showAddButton, guarantorTabEditPrivilege: $scope.guarantorTabEditPrivilege },
                    templateUrl: 'app/private/transaction/loan-application/edit/guarantor/html/view-guarantor-ID-detail.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    multiple: true
                })
                    .then(function (responseData) {
                        if (responseData) {
                            ($scope.vm.guarantorData.TmxGuarantor.TmxPerson.TmxPersonNationalIdentifier).push(responseData);

                        }


                    });
            }

		/****************Personal Assets***********************/
            $scope.addPersonalAssets = function () {
                $scope.viewPersonalAssets(-1, {}, 'true');
            }

            $scope.personalAssetDelete = function (index) {
                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.PersonalAssets.splice(index, 1);
            }

            $scope.viewPersonalAssets = function (index, data, add) {
                var personalAssets = {};
                var showAddButton = false;


                if (add) {
                    showAddButton = true;
                }

                if (index > -1) {
                    personalAssets = $scope.vm.guarantorData.TmxGuarantor.TmxPerson.PersonalAssets[index];
                    showAddButton = false;
                }
                else if (data && Object.keys(data).length) {
                    personalAssets = data;
                    showAddButton = true;
                }

                if ($scope.vm.guarantorData.TmxGuarantor == null) {
                    $scope.vm.guarantorData.TmxGuarantor = {};
                }

                if (!exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.PersonalAssets)) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.PersonalAssets = [];
                }

                $mdDialog.show({
                    controller: 'PersonalAssetsController',
                    controllerAs: 'PersonalAssetsController',
                    locals: { PersonalAssets: personalAssets, showAddButton: showAddButton, guarantorTabEditPrivilege: $scope.guarantorTabEditPrivilege },
                    templateUrl: 'app/private/transaction/loan-application/edit/guarantor/html/view-personal-assets.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    multiple: true
                })
                    .then(function (responseData) {
                        if (responseData) {
                            $scope.vm.guarantorData.TmxGuarantor.TmxPerson.PersonalAssets.push(responseData);
                        }


                    });
            }


		/****************House Hold member ***********************/
            $scope.addHouseholdMembers = function () {
                $scope.viewHouseholdMembers(-1, {}, 'true');
            }

            $scope.deleteHouseHoldMember = function (index) {
                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.HouseholdMembers.splice(index, 1);
            }

            $scope.viewHouseholdMembers = function (index, data, add) {
                var householdMembers = {};
                var showAddButton = false;


                if (add) {
                    showAddButton = true;
                }

                if (index > -1) {
                    householdMembers = $scope.vm.guarantorData.TmxGuarantor.TmxPerson.HouseholdMembers[index];
                    showAddButton = false;
                }
                else if (data && Object.keys(data).length) {
                    householdMembers = data;
                    showAddButton = true;
                }

                if ($scope.vm.guarantorData.TmxGuarantor == null) {
                    $scope.vm.guarantorData.TmxGuarantor = {};
                }

                if (!exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson)) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson = {};
                }

                if (!exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.HouseholdMembers)) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.HouseholdMembers = [];
                }

                $mdDialog.show({
                    controller: 'HouseholdMembersController',
                    controllerAs: 'HouseholdMembersController',
                    locals: { HouseholdMembers: householdMembers, showAddButton: showAddButton, guarantorTabEditPrivilege: $scope.guarantorTabEditPrivilege },
                    templateUrl: 'app/private/transaction/loan-application/edit/guarantor/html/household-members.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    multiple: true
                })
                    .then(function (responseData) {
                        if (responseData) {
                            ($scope.vm.guarantorData.TmxGuarantor.TmxPerson.HouseholdMembers).push(responseData);
                        }


                    });
            }


		/****************Relation with institution table***********************/
            $scope.addRelationWithInstitutionTable = function () {
                $scope.viewRelationWithInstitution(-1, {}, 'true');
            }

            $scope.deleteRelationWithInstitution = function (index) {
                $scope.vm.guarantorData.TmxGuarantor.TmxPerson.RelationWithInstitutions.splice(index, 1);
            }

            $scope.viewRelationWithInstitution = function (index, data, add) {
                var relationWithInstitutions = {};
                var showAddButton = false;


                if (add) {
                    showAddButton = true;
                }

                if (index > -1) {
                    relationWithInstitutions = $scope.vm.guarantorData.TmxGuarantor.TmxPerson.RelationWithInstitutions[index];
                    showAddButton = false;
                }
                else if (data && Object.keys(data).length) {
                    relationWithInstitutions = data;
                    showAddButton = true;
                }

                if (!exists($scope.vm.guarantorData.TmxGuarantor)) {
                    $scope.vm.guarantorData.TmxGuarantor = {};
                }

                if (!exists($scope.vm.guarantorData.TmxGuarantor, 'TmxPerson')) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson = {};
                }

                if (!exists($scope.vm.guarantorData.TmxGuarantor.TmxPerson.RelationWithInstitutions)) {
                    $scope.vm.guarantorData.TmxGuarantor.TmxPerson.RelationWithInstitutions = [];
                }

                $mdDialog.show({
                    controller: 'GuarantorRelationDialogController',
                    controllerAs: 'GuarantorRelationDialogController',
                    locals: { RelationWithInstitutions: relationWithInstitutions, showAddButton: showAddButton, guarantorTabEditPrivilege: $scope.guarantorTabEditPrivilege },
                    templateUrl: 'app/private/transaction/loan-application/edit/guarantor/html/view-guarantor-relation-detail.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    multiple: true
                })
                    .then(function (responseData) {
                        if (responseData) {
                            ($scope.vm.guarantorData.TmxGuarantor.TmxPerson.RelationWithInstitutions).push(responseData);
                            console.log("relationship value" + $scope.vm.guarantorData.TmxGuarantor.TmxPerson.RelationWithInstitutions);
                        }


                    });
            }


		/****************lookup declaration***********************/
            function initializeLookups() {
                $scope.vm.lookup.gender = lookupService.getLocalLookupsByType('GenderID');
                $scope.vm.lookup.vitasGenderLkp = lookupService.getLocalLookupsByType('VITAS_GENDER');
                $scope.vm.lookup.nationality = lookupService.getLocalLookupsByType('VITAS_JORDAN_NATIONALITY');
                $scope.vm.lookup.nationalities = lookupService.getLocalLookupsByType('Nationalities');
                $scope.vm.lookup.idDocumentTypeLkp = lookupService.getLocalLookupsByType('IdentificationDocumentTypes');
                $scope.vm.lookup.educationLkp = lookupService.getLocalLookupsByType('Educations');
                $scope.vm.lookup.yesNoLkp = lookupService.getLocalLookupsByType('YES_NO');
                $scope.vm.lookup.relationshipVitasLkp = lookupService.getLocalLookupsByType('Relationship_Vitas');
                $scope.vm.lookup.clientRelationshipLkp = lookupService.getLocalLookupsByType('ClientRelations');
                $scope.vm.lookup.regionLkp = lookupService.getLocalLookupsByType('Region');
                $scope.vm.lookup.cityLkp = lookupService.getLocalLookupsByType('City');
                $scope.vm.lookup.areaLkp = lookupService.getLocalLookupsByType('Area');
                $scope.vm.lookup.maritalStatusesLkp = lookupService.getLocalLookupsByType('MaritalStatuses');
                $scope.vm.lookup.professionTypesLkp = lookupService.getLocalLookupsByType('ProfessionTypes');
                $scope.vm.lookup.employmentTypesLkp = lookupService.getLocalLookupsByType('EmploymentStatuses');
                $scope.vm.lookup.incomeSourceLkp = lookupService.getLocalLookupsByType('IncomeSource');
                $scope.vm.lookup.GovernorateLkp = lookupService.getLocalLookupsByType('Governorate');
                $scope.vm.lookup.SectorsLkp = lookupService.getLocalLookupsByType('Sectors');
                $scope.vm.lookup.SubSectorsLkp = lookupService.getLocalLookupsByType('Sub-Sector');
                $scope.vm.lookup.OccupationLkp = lookupService.getLocalLookupsByType('Occupation');
                $scope.vm.lookup.OccupationTypeLkp = lookupService.getLocalLookupsByType('EmploymentStatuses');
                $scope.vm.lookup.PropertyListValue = lookupService.getLocalLookupsByType('PropertyListValues');
                $scope.vm.lookup.IdentificationDocumentTypes = lookupService.getLocalLookupsByType('IdentificationDocumentTypes');
                $scope.vm.lookup.Nationality = lookupService.getLocalLookupsByType('Nationality');
                $scope.vm.lookup.contractType = lookupService.getLocalLookupsByType('Contract_type');
                $scope.vm.lookup.cityType = lookupService.getLocalLookupsByType('Suburb');
                $scope.vm.lookup.ownershipLkp = lookupService.getLocalLookupsByType('HouseOwnership');
                $scope.vm.lookup.businessPremises = lookupService.getLocalLookupsByType('Premises_status');
                $scope.vm.lookup.bankMFILkp = lookupService.getLocalLookupsByType('FinancialInstitutionTypes');
                $scope.vm.lookup.bankLkp = lookupService.getLocalLookupsByType('Banks');
                $scope.vm.lookup.addtionalRole = tmxUtility.sortByAttr(lookupService.getLocalLookupsByType('Additional_role'), "HiddenValue");//.sort(function(x){return x.HiddenValue});
                $scope.vm.lookup.NatureofCall = lookupService.getLocalLookupsByType('NatureofCall');
                $scope.vm.lookup.Education = lookupService.getLocalLookupsByType('Education Level');
                $scope.vm.lookup.Religion = lookupService.getLocalLookupsByType('Religion');
                $scope.vm.lookup.SectorCategory = lookupService.getLocalLookupsByType('Sector Category');
                $scope.vm.lookup.SectorTypeCategory = lookupService.getLocalLookupsByType('Sector Type');
                $scope.vm.lookup.BusinessNature = lookupService.getLocalLookupsByType('BusinessNature');
                $scope.vm.lookup.Title = lookupService.getLocalLookupsByType('Title');
                $scope.vm.lookup.ResidenceTypeUS = lookupService.getLocalLookupsByType('Residence Type US');
                $scope.vm.lookup.RuralUrban = lookupService.getLocalLookupsByType('RuralUrban');
                $scope.vm.lookup.Province_ubank = lookupService.getLocalLookupsByType('Province_ubank');
                $scope.vm.lookup.District_ubank = lookupService.getLocalLookupsByType('DISTRICT');
                $scope.vm.lookup.Tehsil_ubank = lookupService.getLocalLookupsByType('TEHSIL');
                $scope.vm.lookup.idType_ubank = lookupService.getLocalLookupsByType('ID Type');
                $scope.vm.lookup.customerType = lookupService.getLocalLookupsByType('Customer Type');
                $scope.vm.lookup.maritialStatus = lookupService.getLocalLookupsByType('Marital Status');
                $scope.vm.lookup.genderLkp = lookupService.getLocalLookupsByType('GENDER');
                $scope.vm.lookup.dictAddressLkp = lookupService.getLocalLookupsByType('DictAddresses');
                $scope.vm.lookup.areaCityLkp = lookupService.getLocalLookupsByType('Area');
                $scope.vm.lookup.GuarantorActivitiesLkp = lookupService.getLocalLookupsByType('Activities');
                $scope.vm.lookup.ClientRelationsLkp = lookupService.getLocalLookupsByType('ClientRelations');
                $scope.vm.lookup.guarantorTypeLkp = lookupService.getLocalLookupsByType('Guarantor_Type');
                $scope.vm.lookup.refferalChannelsLkp = lookupService.getLocalLookupsByType('RefferalChannels');
                $scope.vm.lookup.militaryPositionLkp = lookupService.getLocalLookupsByType('MilitaryPosition');
                $scope.vm.lookup.yesNo = [{VisibleValue:'Yes',HiddenValue:1},{VisibleValue:'No',HiddenValue:0}];
            }

            (function formInitalization() {
                tenantWiseConfiguration();
                initializeLookups();
                calculateTotalLoanAmount();
            })();
        }]);
})();
